import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import store from '@/stores/store';

const { loadFiltersFromStorage, saveFiltersToStorage } = utils;

const DEFAULT_FILTERS = { offset: 0, limit: 100, ordering: 'label' };

const createState = (options = {}) => ({
    producttypes: [],
    producttypes_filters: DEFAULT_FILTERS,
    producttypes_count: 0,
    producttypes_loaded: false,
    producttypes_loading: false,
    producttypes_loading_errors: null,
    cancelTokenSource: null,
    _storageOptions: options || {},
});

const mutations = {
    updateProductTypes(state, producttypes) {
        state.producttypes = producttypes;
        state.producttypes_loaded = true;
        state.producttypes_loading = false;
        state.producttypes_loading_errors = null;
    },
    updateProductTypesFilters(state, producttypes_filters) {
        state.producttypes_filters = producttypes_filters;
        const { storageKey, fieldsToSave } = state._storageOptions;
        if (storageKey) {
            saveFiltersToStorage(storageKey, state.producttypes_filters, fieldsToSave);
        }
    },
    updateProductTypesLoading(state, producttypes_loading) {
        state.producttypes_loading = producttypes_loading;
    },
    updateProductTypesLoadingErrors(state, producttypes_loading_errors) {
        state.producttypes_loading_errors = producttypes_loading_errors;
        state.producttypes_loading = false;
    },
    updateCancelTokenSource(state, source) {
        state.cancelTokenSource = source;
    },
    updateStorageOptions(state, storage_options) {
        state._storageOptions = storage_options;
    },
};

const actions = {

    async fetchProductTypes({ commit, dispatch, state }, params) {
        // Cancel any pending request
        if (state.cancelTokenSource) {
            state.cancelTokenSource.cancel("New fetch started");
        }

        // Create new cancel token source
        const source = axios.CancelToken.source();
        commit('updateCancelTokenSource', source);

        commit('updateProductTypesLoading', true);
        commit('updateProductTypesLoadingErrors', null);

        try {
            const response = await axios.get("/api/producttypes/", {
                params: state.producttypes_filters,
                cancelToken: source.token,
            });
            commit('updateProductTypes', response.data.results);
            return response;
        } catch (xhr_error) {
            // Ignore cancelled requests
            if (axios.isCancel(xhr_error)) {
                return;
            }
            const error = utils.handleError(xhr_error);
            commit('updateProductTypesLoadingErrors', error.details);
            throw error;
        } finally {
            commit('updateProductTypesLoading', false);
        }
    },

    async init({ commit, dispatch, state }, params) {
        commit('updateProductTypes', []);
        
        // Update storage options if provided
        if (params?.storageOptions !== undefined) {
            await commit('updateStorageOptions', params.storageOptions);
        }
        
        // Load filters from localStorage if storage is configured
        await commit('updateProductTypesFilters', { 
            ...DEFAULT_FILTERS, 
            ...(state._storageOptions?.storageKey ? loadFiltersFromStorage(state._storageOptions?.storageKey, {}) : {}),
            ...(params?.filters || {})
        });
    },
};


export default (options = {}) => ({
    namespaced: true,
    state: createState(options),
    mutations,
    actions
});